import { TaskQueueManager } from 'crm-timeline-tasks/queues/data/TaskQueueManager';
import { useQueryParams } from './useQueryParams';

/**
 * TODO: Need to identify if there is any alternative approach to set taskId from records page.
 * Explanation: Task updates records URL with task ID. When Note engagement is clicked,
 * there is currently no direct method to link this task ID with interaction configuration,
 * so doing lookup at records page instead of in window Body component ( activity creator ).
 */
export const useActiveTaskId = () => {
  const {
    taskId
  } = useQueryParams();
  const taskIdFromQueryParam = parseInt(String(taskId), 10);
  if (taskIdFromQueryParam) {
    return taskIdFromQueryParam;
  }
  const {
    currentTaskId
  } = TaskQueueManager.getState({
    force: true
  });
  return currentTaskId;
};